var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoinformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "100px",
    height: "100px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#028383",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,1c-13.77734,0 -25,9.87891 -25,22.1875c0,6.04688 2.77344,11.47656 7.21875,15.5c-0.67187,2.07422 -2.17187,3.71094 -3.6875,4.96875c-0.81641,0.67578 -1.59766,1.25391 -2.21875,1.8125c-0.30859,0.27734 -0.58984,0.55859 -0.8125,0.90625c-0.22266,0.34766 -0.42187,0.84375 -0.28125,1.375l0.125,0.40625l0.34375,0.21875c1.28906,0.74219 2.89453,0.87109 4.625,0.75c1.73047,-0.12109 3.61719,-0.51953 5.46875,-1.03125c3.59375,-0.99219 6.96875,-2.40625 8.75,-3.1875c1.75781,0.36719 3.52344,0.59375 5.375,0.59375c13.77734,0 25,-9.87891 25,-22.1875c0,-12.30469 -11.125,-22.3125 -24.90625,-22.3125zM25,3c12.82031,0 22.90625,9.21484 22.90625,20.3125c0,11.08984 -10.17578,20.1875 -23,20.1875c-1.82812,0 -3.55078,-0.17969 -5.28125,-0.5625l-0.34375,-0.09375l-0.28125,0.15625c-1.67187,0.73828 -5.20703,2.17969 -8.75,3.15625c-1.77344,0.48828 -3.53906,0.86328 -5.0625,0.96875c-1.01953,0.07031 -1.64844,-0.17187 -2.34375,-0.34375c0.49609,-0.42578 1.17578,-0.93359 1.96875,-1.59375c1.74219,-1.44531 3.83203,-3.45703 4.5625,-6.4375l0.15625,-0.625l-0.5,-0.375c-4.40625,-3.73437 -7.03125,-8.875 -7.03125,-14.5625c0,-11.08984 10.17578,-20.1875 23,-20.1875zM23.8125,12.8125c-0.30078,0 -0.40625,0.17578 -0.40625,0.375v2.625c0,0.30078 0.20703,0.375 0.40625,0.375h2.375c0.30078,0 0.40625,-0.17578 0.40625,-0.375v-2.625c0,-0.30078 -0.20703,-0.375 -0.40625,-0.375zM23.90625,20.09375c-0.30078,0 -0.40625,0.20703 -0.40625,0.40625v13.40625c0,0.30078 0.20703,0.40625 0.40625,0.40625v0.09375h2.28125c0.30078,0 0.40625,-0.20703 0.40625,-0.40625v-13.5c0,-0.30078 -0.20703,-0.40625 -0.40625,-0.40625z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoinformation);
export default __webpack_public_path__ + "static/media/noinformation.8ca0585aea2a7c596e964bb61c6c8c37.svg";
export { ForwardRef as ReactComponent };